import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-string-modal',
  templateUrl: './edit-string-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-string-modal.component.scss']
})
export class EditStringModalComponent {
  public wellStringForm: FormGroup
  public isSuccess : boolean = false
  public isLoading : boolean = false

  public stringIndicatorList : string[] = [
    'U',
    'L',
    'Single'
  ]

  constructor(
    public dialogRef: MatDialogRef<EditStringModalComponent>,
    @Inject(MAT_DIALOG_DATA) public stringData: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderInfoService : WellHeaderInfoService
    ) { }

  ngOnInit() {
    this.wellStringForm = this.initializeForm()

    this.wellStringForm.get('stringShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.wellStringForm.get('stringShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });

        this.wellStringForm.get('stringIndicatorShortName')?.valueChanges.subscribe(value => {
      if (value && value == 'U') {
        this.wellStringForm.get('stringIndicatorLongName')?.setValue('Upper', { emitEvent: false });
      } else if (value && value == 'L') {
        this.wellStringForm.get('stringIndicatorLongName')?.setValue('Lower', { emitEvent: false });
      } else if (value && value == 'Single') {
        this.wellStringForm.get('stringIndicatorLongName')?.setValue('Single', { emitEvent: false });
      }
    });
  }

  initializeForm() {
    return this.fb.group({
      id: this.stringData.wellStringId,
      wellId:this.stringData.wellId,
      wellboreId:this.stringData.wellboreId,
      stringShortName: [ this.stringData.name, [Validators.required, noWhitespaceValidator()]],
      stringLongName: [ this.stringData.longName, [Validators.required, noWhitespaceValidator()]],
      stringStatus: this.stringData.status,
      stringIndicatorLongName: this.stringData.stringIndicatorLongName,
      stringIndicatorShortName: this.stringData.stringIndicatorShortName,
      reservoirZone: '',
      tubingSize: 0,
      remarks: '',
    })
  }

  updateWellString(){
    this.isLoading = true
        
    this.wellHeaderInfoService.updateWellString(this.wellStringForm.value).subscribe({
      next: (res) => {
        if(res.isSuccess){
          this.isSuccess = true
          this.closeDialog()
        }

        this.isLoading = false
      },
      error: (e) => this.isLoading = false
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get stringShortName() {
    return this.wellStringForm.get('stringShortName');
  }

  get stringLongName() {
    return this.wellStringForm.get('stringLongName');
  }
}
